import * as actionTypes from "../actionTypes";

let orderActionCreators = (data, actionType) => {
  return {
    type: actionTypes[actionType],
    payload: data,
  };
};

export const findActiveOrders = (orders) => {
  return orderActionCreators(orders, actionTypes.ACTIVE_ORDERS);
};
export const findRejectedOrders = (orders) => {
  return orderActionCreators(orders, actionTypes.REJECTED_ORDER);
};
export const findReadyToSendOrders = (orders) => {
  return orderActionCreators(orders, actionTypes.READY_TO_SEND);
};

export const findOrdersHistory = (orders) => {
  return orderActionCreators(orders, actionTypes.ORDERS_HISTORY);
};

export const getSubOrders = (orders) => {
  return orderActionCreators(orders, actionTypes.SUB_ORDERS);
};
export const setQrCode = (code) => {
  return orderActionCreators(code, actionTypes.QRCODE);
};

export const set_Qr_Loading = (data) => {
  return orderActionCreators(data, actionTypes.QR_LOAD);
};
export const set_Load_Download = (data) => {
  return orderActionCreators(data, actionTypes.LOAD_DOWNLOAD);
};
export const set_Message = (data) => {
  return orderActionCreators(data, actionTypes.MESSAGE);
};
export const set_Current_Order = (data) => {
  return orderActionCreators(data, actionTypes.CURRENT_ORDER);
};
export const set_active_ready_orders_Length = (data) => {
  return orderActionCreators(data, actionTypes.SET_ORDERS_LENGTH);
};
